import React from 'react'
import { Link } from 'react-router-dom'

interface DashboardCardProps {
  to: string
  gradient: string
  accentColor: string
  badgeIcon: string
  badgeLabel: string
  title: string
  watermarkIcon: string
  metaLabel: string
  value: string | number
  valueSuffix?: string
  topRightIcon: string
}

export default function DashboardCard({
  to,
  gradient,
  accentColor,
  badgeIcon,
  badgeLabel,
  title,
  watermarkIcon,
  metaLabel,
  value,
  valueSuffix,
  topRightIcon,
}: DashboardCardProps) {
  return (
    <Link to={to} className="col-xxl-4 col-md-6" style={{ textDecoration: 'none' }}>
      <div
        className="card border-0 rounded-4 text-white position-relative overflow-hidden shadow-sm"
        style={{ background: gradient, minHeight: '234px' }}
      >
        <div
          className="position-absolute"
          style={{
            right: '-10px',
            bottom: '-30px',
            fontSize: '160px',
            lineHeight: '1',
            pointerEvents: 'none',
            transform: 'rotate(-15deg)',
            color: 'rgba(255,255,255,0.05)',
          }}
        >
          <i className={`bi ${watermarkIcon}`}></i>
        </div>

        <div className="card-body p-4 d-flex flex-column justify-content-between h-100 position-relative z-1">
          <div className="d-flex align-items-start justify-content-between">
            <div>
              <span
                className="badge bg-black bg-opacity-20 px-2 py-1 rounded-pill mb-2 fw-bold"
                style={{ fontSize: '10px', letterSpacing: '0.5px', color: accentColor }}
              >
                <i className={`bi ${badgeIcon} me-1`}></i>
                {badgeLabel}
              </span>
              <h5
                className="card-title fw-bold m-0 pb-0"
                style={{ fontSize: '17px', letterSpacing: '0.3px', color: 'rgba(255,255,255,0.75)' }}
              >
                {title}
              </h5>
            </div>
            <div
              className="bg-black bg-opacity-20 border border-white border-opacity-10 rounded-3 p-2 d-flex align-items-center justify-content-center"
              style={{ width: '42px', height: '42px', color: accentColor }}
            >
              <i className={`bi ${topRightIcon} fs-4`}></i>
            </div>
          </div>

          <div className="pt-2">
            <div className="d-flex align-items-end justify-content-between">
              <div>
                <div className="small font-monospace" style={{ fontSize: '11px', color: 'rgba(255,255,255,0.7)' }}>
                  {metaLabel}
                </div>
                <div className="d-flex align-items-baseline">
                  <span className="display-6 fw-bold text-white lh-1">{value}</span>
                  {valueSuffix && (
                    <span className="small ms-2 fw-bold font-monospace" style={{ color: accentColor }}>
                      {valueSuffix}
                    </span>
                  )}
                </div>
              </div>
              <div
                className="rounded-circle d-flex align-items-center justify-content-center text-white"
                style={{ width: '36px', height: '36px', background: 'rgba(255,255,255,0.15)' }}
              >
                <i className="bi bi-arrow-right fs-5"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
}
